module.exports = __webpack_public_path__ + "img/goldregen-2020-014.0a91ec19.jpg";